const remapDeprecatedColors = (color) => {
  const mapping = {
    lava10: "cream",
    ocean10: "acidWash",
    sun10: "neutral200",
    white: "neutral100"
  };
  return mapping[color] || color;
};
const breakpoints = {
  tablet: 768,
  desktop: 1230
};

export { breakpoints, remapDeprecatedColors };
//# sourceMappingURL=TestimonialMapping.es.js.map
